import { render, staticRenderFns } from "./newsletter-subscription.vue?vue&type=template&id=36ba0354"
import script from "./newsletter-subscription.vue?vue&type=script&lang=js"
export * from "./newsletter-subscription.vue?vue&type=script&lang=js"
import style0 from "./newsletter-subscription.scss?vue&type=style&index=0&prod&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports